import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class SpectralEmbeddingGraph extends AbstractScatterVisualization {
}
